import { gql } from 'apollo-angular';

/*
 * Participants by rfp (for the buyer side)
 */
const GET_RFP_PARTICIPANTS = gql`
  query getRfpParticipants($rfpId: Long) {
    rfp(id: $rfpId) {
      participants {
        participant
        buyer {
          id
          name
          address {
            city
            state
          }
        }
        potentialSavings {
          savingsVolume
        }
        spend {
          continuedSpend
          actualSpend
          annualizedSpend
          annualizedActualSpend
        }
      }
    }
  }
`;

export default GET_RFP_PARTICIPANTS;

